module.exports = require("npm:readable-stream@2.1.2/readable.js");